import { render } from "./requests.vue?vue&type=template&id=794777f6"
import script from "./requests.vue?vue&type=script&lang=js"
export * from "./requests.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Development\\vue\\okraina.sbs.monitor\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__